function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
}

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input.txtbox');
        this.predictiveSearchResults = this.querySelector('.predictive-search-container');

        this.input?.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        document.addEventListener("click", (evt) =>{
            let targetEl = evt.target;
            // if(targetEl !== this.predictiveSearchResults){
            //     this.close();
            // }
            // else if(targetEl === this){
            //     this.open();
            // }
            do{
                if(targetEl === this.predictiveSearchResults){
                    return;
                }
                if(targetEl === this){
                    this.onChange();
                }
                targetEl = targetEl.parentNode;
            }while(targetEl);
            this.close();
        })
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[options][fields]=body,product_type,tag,title,variants.title,vendor&resources[limit]=3&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }
                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.predictiveSearchResults.innerHTML = resultsMarkup;
                // this.mobilePredictiveSearchResults.innerHTML = resultsMarkup;
                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }
}

customElements.define('predictive-search', PredictiveSearch);